import React, { useState } from 'react'
import '../../Assets/Css/MarkAttendance.scss'
import Select from "react-select";
import { customStyle } from '../../Components/Style';
import ReactDatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import { Month, generateYearOptions, Department } from '../../Lib/utils';

const Employee = [
  { value: 'Employee1', label: 'Employee1' },
  { value: 'Employee2', label: 'Employee2' },
  { value: 'Employee3', label: 'Employee4' },
  { value: 'Employee4', label: 'Employee4' },
]

const Location = [
  { value: 'Ahmedabad', label: 'Ahmedabad' },
  { value: 'Jamnagar', label: 'Jamnagar' },
]

const hours = Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: (i + 1).toString().padStart(2, '0') }));
const minutes = Array.from({ length: 60 }, (_, i) => ({ value: i, label: i.toString().padStart(2, '0') }));
const amPm = [
  { value: 'AM', label: 'AM' },
  { value: 'PM', label: 'PM' }
];

const Workfrom = [
  { value: 'Office', label: 'Office' },
  { value: 'Home ', label: 'Home' },
  { value: 'Other', label: 'Other' },
]

const Priority = [
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' },
]

function MarkAttendance() {
  const [Fields, setFields] = useState({
    Department: "",
    Employee: "",
    Location: "",
    Year: "",
    Month: "",
    Date: "",
    AttendanceRadio: "month",
    LateRadio: "",
    HalfDayRadio: "",
    Workfrom: ""
  });
  const [clockIn, setclockIn] = useState({
    hour: null,
    minute: null,
    amPm: null
  });

  const [clockOut, setclockOut] = useState({
    hour: null,
    minute: null,
    amPm: null
  });

  const navigate = useNavigate();
  const Year= generateYearOptions()

  return (
      <div className='TaskEmployee-main mb-5'>
        <div className="page-title">
          <h4> Attendance Details</h4>
          <div className="edit-btn">
            <button
              type="submit"
              className="custom-btn"
              onClick={() => navigate(-1)}
            >
              {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
              Cancel
              {/* )} */}
            </button>

            <button
              type="submit"
              className="custom-btn"
              onClick={() => navigate(-1)}
            >
              {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
              Save
              {/* )} */}
            </button>
          </div>
        </div>

        <div className='row parent-filter m-0 p-4 h-auto'>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <div className='input-group'>
              <label className='label'>Department</label>
              <Select
                value={Fields.Department}
                onChange={(data) =>
                  setFields({
                    ...Fields,
                    Department: data,
                  }
                  )
                }
                options={Department}
                placeholder={"--"}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#5757fe",
                    primary: "#5757fe",
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-9 col-md-9 col-sm-12">
            <div className='input-group'>
              <label className='label'>Employee *</label>
              <Select
                value={Fields.Employee}
                onChange={(data) =>
                  setFields({
                    ...Fields,
                    Employee: data,
                  }
                  )
                }
                options={Employee}
                placeholder={"Employee"}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#5757fe",
                    primary: "#5757fe",
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-12 ">
            <div className='input-group'>
              <label className='label'>Location</label>
              <Select
                value={Fields.Location}
                onChange={(data) =>
                  setFields({
                    ...Fields,
                    Location: data,
                  }
                  )
                }
                options={Location}
                placeholder={"Location"}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#5757fe",
                    primary: "#5757fe",
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-12">
            <div className='input-group'>
              <div>
                <label className='label'>Mark Attendance By</label>
              </div>
              <div className='attandance_radio_grp'>
                <div className="radiobtn">
                  <input
                    type="radio"
                    name='attendance'
                    value='month'
                    checked={Fields.AttendanceRadio === 'month'}
                    onChange={(data) => {
                      setFields({
                        ...Fields,
                        AttendanceRadio: data.target.value,
                      }
                      )
                    }}
                  />
                  <lable className="label">Month</lable>
                </div>
                <div className="radiobtn ms-3">
                  <input
                    type="radio"
                    name='attendance'
                    value='date'
                    checked={Fields.AttendanceRadio === 'date'}
                    onChange={(data) => {
                      setFields({
                        ...Fields,
                        AttendanceRadio: data.target.value,
                      }
                      )
                    }}
                  />
                  <lable className="label">Date</lable>
                </div>
              </div>
            </div>
          </div>

          {Fields.AttendanceRadio === "month" ? (
            <>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className='input-group'>
                  <label className='label'>Year *</label>
                  <Select
                    value={Fields.Year}
                    onChange={(data) =>
                      setFields({
                        ...Fields,
                        Year: data,
                      }
                      )
                    }
                    options={Year}
                    placeholder={"Year"}
                    styles={customStyle}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                </div>
              </div>


              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className='input-group'>
                  <label className='label'>Month *</label>
                  <Select
                    value={Fields.Month}
                    onChange={(data) =>
                      setFields({
                        ...Fields,
                        Month: data,
                      }
                      )
                    }
                    options={Month}
                    placeholder={"Month"}
                    styles={customStyle}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className='col-lg-6 col-md-6 col-sm-12'>
              <div className='input-group'>
                <lable className='label'>Date *</lable>
                <ReactDatePicker
                  selected={Fields.Date}
                  format="yyyy-MM-dd"
                  placeholderText='Date'
                  onChange={(date) => {
                    setFields({
                      ...Fields,
                      Date: date,
                    });
                  }}
                  className='date-picker'
                />
              </div>
            </div>
          )
          }

          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 task-catagory">
            <div className="input-group">
              <label className="label">Clock In *</label>
              <div className="dropdown-grp">
                <Select
                  value={clockIn.hour}
                  onChange={(data) => setclockIn({ ...clockIn, hour: data })}
                  options={hours}
                  placeholder="Hour"
                  styles={customStyle}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
                <Select
                  value={clockIn.minute}
                  onChange={(data) => setclockIn({ ...clockIn, minute: data })}
                  options={minutes}
                  placeholder="Minute"
                  styles={customStyle}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
                <Select
                  value={clockIn.amPm}
                  onChange={(data) => setclockIn({ ...clockIn, amPm: data })}
                  options={amPm}
                  placeholder="AM/PM"
                  styles={customStyle}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 task-catagory">
            <div className="input-group">
              <label className="label">Clock Out</label>
              <div className="dropdown-grp">
                <Select
                  value={clockOut.hour}
                  onChange={(data) => setclockOut({ ...clockOut, hour: data })}
                  options={hours}
                  placeholder="Hour"
                  styles={customStyle}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
                <Select
                  value={clockOut.minute}
                  onChange={(data) => setclockOut({ ...clockOut, minute: data })}
                  options={minutes}
                  placeholder="Minute"
                  styles={customStyle}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
                <Select
                  value={clockOut.amPm}
                  onChange={(data) => setclockOut({ ...clockOut, amPm: data })}
                  options={amPm}
                  placeholder="AM/PM"
                  styles={customStyle}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className='input-group'>
              <div>
                <label className='label'>Late</label>
              </div>
              <div className='attandance_radio_grp'>
                <div className="radiobtn">
                  <input
                    type="radio"
                    name='late'
                    value='yes'
                    checked={Fields.LateRadio === 'yes'}
                    onChange={(data) => {
                      setFields({
                        ...Fields,
                        LateRadio: data.target.value,
                      }
                      )
                    }}
                  />
                  <lable className="label">Yes</lable>
                </div>
                <div className="radiobtn ms-3">
                  <input
                    type="radio"
                    name='late'
                    value='no'
                    checked={Fields.LateRadio === 'no'}
                    onChange={(data) => {
                      setFields({
                        ...Fields,
                        LateRadio: data.target.value,
                      }
                      )
                    }}
                  />
                  <lable className="label">No</lable>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className='input-group'>
              <div>
                <label className='label'>Half Day</label>
              </div>
              <div className='attandance_radio_grp'>
                <div className="radiobtn">
                  <input
                    type="radio"
                    name='halfday'
                    value='yes'
                    checked={Fields.HalfDayRadio === 'yes'}
                    onChange={(data) => {
                      setFields({
                        ...Fields,
                        HalfDayRadio: data.target.value,
                      }
                      )
                    }}
                  />
                  <lable className="label">Yes</lable>
                </div>
                <div className="radiobtn ms-3">
                  <input
                    type="radio"
                    name='halfday'
                    value='no'
                    checked={Fields.HalfDayRadio === 'no'}
                    onChange={(data) => {
                      setFields({
                        ...Fields,
                        HalfDayRadio: data.target.value,
                      }
                      )
                    }}
                  />
                  <lable className="label">No</lable>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-12">
            <div className='input-group'>
              <lable className='label'>Working From *</lable>
              <Select
                value={Fields.Workfrom}
                onChange={(data) =>
                  setFields({
                    ...Fields,
                    Workfrom: data,
                  }
                  )
                }
                options={Workfrom}
                placeholder={"Work From"}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#5757fe",
                    primary: "#5757fe",
                  },
                })}
              />
            </div>
          </div>

        </div>
      </div>
  )
}

export default MarkAttendance